<template>
  <div class="label-wrap">
    <div
      class="title"
      :class="[{ 'is-must': isMust }, { 'is-need-line': isNeedLine }]"
    >
      {{ title }}
    </div>
   <slot></slot>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance
} from "@vue/composition-api";

export default defineComponent({
  name: "LabelCom",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: ""
    },
    isMust: {
      type: Boolean,
      default: false
    },
    isNeedLine: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const state = reactive({
    });

    return {
      ...toRefs(state)
    };
  }
});
</script>
<style lang="less" scoped>
.label-wrap {
  padding: 28px 0;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #020f22;
  font-weight: 400;
  position: relative;
  padding-right: 40px;
  .title {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #7e8388;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 16px;
  }
  .placeholder {
    color: #a4abb0;
  }
  .is-must {
    &::after {
      content: "*";
      color: #ff4d4f !important;
    }
  }
  .is-need-line {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #ebedf0;
      transform: rotateY(0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/labelCom.vue